'use client'

import { SWRConfig } from 'swr'

type SWRConfigProviderProps = {
  children: React.ReactNode
}

export default function SWRConfigProvider({ children }: SWRConfigProviderProps) {
  return <SWRConfig value={{ fetcher: (resource, init) => fetch(resource, init).then(res => res.json()) }}>{children}</SWRConfig>
}
